import { useEffect } from "react";

export default function usePageRefresh(callback) {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (callback) {
        callback(event);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [callback]);
}
